import React, { useState } from 'react';
import '../../css/cmeCardV2.scss';
import { ClirnetFullLogo, ClockCircleOutline, GoCalender } from '../../../../icons';
import {
  LeftCorner,
  LiveIcon,
  RightCorner,
  CardBackground
} from '../../images/ctaBackgroundImages';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import LazyImage from '../../../../CustomLibraries/LazyImage';
import { useReserveSession } from '../../../../../Queries/QueryHooks/session.hook';
import { DEMO_USER_PICTURE, getLocalStorage } from '../../../../../common/common';
import { isMobile, isMobileOnly } from 'react-device-detect';

export default function CmeCardV2({
  data = '',
  click,
  // masonryClass,
  // positionClass
  masonaryArr
}) {
  const {
    session_id,
    session_topic,
    session_description,
    display_date_format,
    display_date,
    sponsor_logo,
    session_doctor_entities
  } = data;
  const [text, setText] = useState('Click here to Register');

  const userDetails = () => (getLocalStorage('user', false) ? getLocalStorage('user', {}) : {});
  const onSuccessCb = () => {
    setText('Registered');
    click();
  };
  const { mutate: reserve, isLoading } = useReserveSession('submit', session_id, onSuccessCb);
  const reservation = () => {
    if (isLoading) {
      return false;
    }
    let parser = {
      session_id,
      question: '',
      my_participant_id: '',
      attachFilePath: '',
      utm_source: '',
      redirect_to_live: 0,
      first_name: userDetails()?.first_name,
      last_name: userDetails()?.last_name
    };
    reserve({ type: 'submit', parser });
  };
  return (
    // <div className="ctaMD4 position-relative ctaManualCard">
    // <div className="ctaMD6 position-relative ctaManualCard">
    <div
      className={`${masonaryArr[0] == 'col-md-4'
        ? 'ctaMD4'
        : masonaryArr[0] == 'col-md-6'
          ? 'ctaMD6'
          : masonaryArr.length == 0
            ? 'ctaMD4'
            : isMobileOnly
              ? 'ctaMD4'
              : isMobile
                ? 'ctaMD6'
                : ''
        } position-relative ctaManualCard p-4 overflow-hidden rounded-4
      `}
    >
      <div className="ctaContent w-100 h-100 d-flex flex-column position-relative z-2">
        <div className="ctaContentHeader ctaLogo d-flex flex-column flex-sm-row align-items-center flex-column gap-1 position-relative pb-3">
          <div className="ctaLive">
            <LiveIcon className="w-auto" />
          </div>
          <div className="ctaLiveText text-center d-flex flex-column align-items-center justify-content-center w-100 content px-4">
            <h3 className="fs-1 fw-semibold lh-base m-0">Live Digital CME on</h3>
            {session_topic && (
              <h2 className="fs-1 fw-bold line-clamp-1 lh-base mb-2">{session_topic}</h2>
            )}
            {session_description && (
              <h4 className="fs-16 fw-bold line-clamp-2 lh-base mb-3">{session_description}</h4>
            )}
          </div>
        </div>

        <div className="ctaContentBody d-flex flex-column flex-sm-row justify-content-between align-items-center">
          {session_doctor_entities.length === 1 && (
            <div className="ctadoctorImage w-100 d-flex flex-column flex-sm-row position-relative align-items-end">
              <div className="doct z_index_1">
                <LazyImage
                  className="rounded-circle border border-4"
                  src={session_doctor_entities[0].session_doctor_image}
                  alt={session_doctor_entities[0].session_doctor_name}
                  fallback_image={DEMO_USER_PICTURE}
                />
              </div>
              <div className="ctadoctorContent position-relative py-3 text-start">
                <h1 className="text-white fs-1 fw-semibold line-clamp-1">
                  {session_doctor_entities[0].session_doctor_name}
                </h1>
                <h3 className="text-white fs-16 fw-normal m-0 line-clamp-2">
                  {session_doctor_entities[0].DepartmentName}
                </h3>
                <span className="doctorContentgraph"></span>
              </div>
            </div>
          )}
          {session_doctor_entities.length > 1 && (
            <Swiper
              className="w-100 flex_1"
              navigation={false}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 2500
              }}
              effect="fade"
            >
              {session_doctor_entities.map((entity, index) => {
                return (
                  <SwiperSlide key={index + 1}>
                    <div className="ctadoctorImage w-100 d-flex flex-column flex-sm-row position-relative align-items-end">
                      <div className="doct z_index_1">
                        <LazyImage
                          className="rounded-circle border border-4"
                          src={entity.session_doctor_image}
                          alt={entity.session_doctor_name}
                          fallback_image={DEMO_USER_PICTURE}
                        />
                      </div>
                      <div className="ctadoctorContent position-relative py-3 text-start">
                        <h1 className="text-white fs-1 fw-semibold line-clamp-1">
                          {entity.session_doctor_name}
                        </h1>
                        <h3 className="text-white fs-16 fw-normal m-0 line-clamp-2">
                          {entity.DepartmentName}
                        </h3>
                        <span className="doctorContentgraph"></span>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}

          <div className="date d-flex flex-column gap-3 mt-auto">
            {display_date_format && (
              <div className="d-flex gap-4 justify-content-start align-items-center">
                {/* <GoCalender customClass="wh_30" /> */}
                <i className="flaticon-calendar fs-1 text-white"></i>
                <h2 className="fs-1 fw-semibold ">{display_date_format}</h2>
              </div>
            )}
            {display_date && (
              <div className="d-flex gap-4 justify-content-start align-items-center">
                {/* <ClockCircleOutline customClass="wh_30" /> */}
                <i className="flaticon-clock fs-1 text-white"></i>
                <h2 className="fs-1 fw-semibold">{display_date}</h2>
              </div>
            )}
          </div>
        </div>

        <div className="ctaContentFooter mt-4 mb-2 d-flex flex-column flex-sm-row ctaLogo align-items-center">
          <div className="flex_1 d-flex justify-content-center" onClick={reservation}>
            <span className="registerBtn fs-16 fw-semibold rounded-4 px-4 py-3 cursorPointer">
              {isLoading ? 'Please wait...' : text ?? ''}
            </span>
          </div>
          <div className="ctaClirnet ms-auto mt-3">
            <Swiper
              navigation={false}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 2500
              }}
            // effect={'fade'}
            >
              {sponsor_logo &&
                sponsor_logo.split(',')?.length > 0 &&
                sponsor_logo.split(',').map((logo, index) => {
                  return (
                    <SwiperSlide key={index + 1}>
                      <LazyImage className="w-100 h-100" src={logo} />
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </div>
      </div>

      <CardBackground />
      <div className="ctaCornerImage w-100 h-100 position-absolute top-0 start-0 z-1">
        <div className="leftCorner position-absolute bottom-0 left-0">
          <LeftCorner />
        </div>
        <div className="rightCorner position-absolute end-0 top-0">
          <RightCorner />
        </div>
      </div>
    </div>
  );
}
